import React, { Component } from 'react'
import './Features.scss'
import Card from '../../Components/Card/Card'
import { Link } from 'react-router-dom'

export default class Features extends Component {
    render() {
        return (
            <div className="features">

                <h1>Features <img alt='features' src={'https://image.flaticon.com/icons/svg/2835/2835113.svg'}></img></h1>

                <div className="cards">
                    <Card
                        image={'https://i.picsum.photos/id/546/350/200.jpg?hmac=EDVO-0SR9kpa5l_2WVGLyqacRr51ChnF1U47-fq8MIg'}
                        title={'Animated Video Lectures'}
                        content={'Students often don’t pay attention in classes because they don’t feel connected to the subject. For this reason, we will establish that connection by using stories in our video lecture. Then explain concept using gamification and adding interesting and funny anecdotes.'}
                    />


                    <Link className='ic-card' to={'/discussion'}>
                        <Card
                            image={'https://i.picsum.photos/id/534/350/200.jpg?hmac=OgC8HVtolfHCpbTlsLHmpR-ojMGkvl6JoDlskNs6WLM'}
                            title={'Creative Discussion'}
                            content={'Students are often confused or worried on how to build their career? This will be a platform where Students can share their doubts and expect answer from students and teachers. They can interact, build connection and in the process enhance their communication skills.'}
                        />
                    </Link>


                    <Card
                        image={'https://i.picsum.photos/id/662/350/200.jpg?hmac=708gIFuKPPnM3zUpyIr-AgV0GhLEHIyXKscemYH-3YE'}
                        title={'Distinctive Courses'}
                        content={'Our education system is so rigid that it doesn\'t allow student to learn Science and arts together. We will provide students with courses where they can learn subject which aren’t in their curriculum Eg – Summary of Vedas,  Think like a Philosopher, etc.'}
                    />
                </div>

            </div>
        )
    }
}
